import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "sensor",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.904 13.88A5.983 5.983 0 0 1 1.93 7.904h-1.93c0 4.36 3.547 7.905 7.905 7.905zm0-13.88v1.929a5.98 5.98 0 0 1 5.976 5.975h1.929C15.809 3.546 12.263 0 7.904 0m1.489 11.674.125-.052c.467-.2.888-.487 1.253-.851L9.407 9.407q-.286.286-.645.441l-.089.037q-.364.144-.769.144c-.405 0-.526-.048-.768-.144l-.088-.036a2.1 2.1 0 0 1-.646-.442l-1.364 1.364c.365.365.786.651 1.254.852l.125.052c.472.188.972.283 1.487.283s1.017-.096 1.489-.284m.014-5.272a2.1 2.1 0 0 0-.646-.442l-.088-.036a2.1 2.1 0 0 0-.769-.145c-.267 0-.526.049-.768.145l-.089.036a2.1 2.1 0 0 0-.645.442L5.038 5.038a4 4 0 0 1 1.253-.852l.126-.052a4 4 0 0 1 1.487-.283c.516 0 1.016.095 1.489.283l.125.052c.467.2.889.488 1.253.852z",
  mask: "url(#b)",
  style: {"stroke":"none","stroke-opacity":"1","fill":"#0d4760","fill-opacity":"1"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }